import { SVGAttributes } from "react";

const AboutIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 6.08118C2 3.87204 3.79086 2.08118 6 2.08118C8.20914 2.08118 10 3.87204 10 6.08118C10 7.59537 9.15865 8.91305 7.91794 9.59223C6.94905 10.1226 6 10.9766 6 12.0812V14.0812"
        stroke="#FFA686"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle cx="6" cy="14.0812" r="2" fill="#CFB2FF" />
    </svg>
  );
};

export default AboutIcon;
